<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Exportation de Stock</h1>
    <div class="mb-6 flex justify-between items-center">
      <div class="flex">
      </div>
    </div>
    <div class="bg-white rounded shadow overflow-hidden max-w-7xl pt-4">
      <div class="md:inline-flex space-y-4 md:space-y-0 w-full py-4 px-6 items-center">
        <h2 class="md:w-1/3 max-w-sm mx-auto font-medium text-gray-500 text-lg">Stock:</h2>
        <div class="md:w-2/3 mx-auto">
          <div>
            <div v-if="isMainShop">
              <label>Shops:</label>
              <div class="">
                <div v-for="shop in $page.props.shops" class="inline-flex flex-row pb-4 pr-6">
                  <label class="py-3">
                    <input type="checkbox" class="form-checkbox" :value="shop.id" v-model="shops">
                    <span class="ml-2 text-md font-bold text-gray-600">{{ shop.name }}</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-span-6 sm:col-span-2">
              <loading-button :loading="sending" class="btn-indigo mx-auto my-0" type="submit" @click.native="exportStock">Exporter
              </loading-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import LoadingButton from '@/Shared/LoadingButton'
import Layout from '@/Layouts/AppLayout'
import mapValues from 'lodash/mapValues'
import pickBy from 'lodash/pickBy'
import SearchFilter from '@/Shared/SearchFilter'
import throttle from 'lodash/throttle'
import Input from "../../Jetstream/Input";

export default {
  metaInfo: {title: 'Exportation de Stock'},
  layout: Layout,
  components: {
    Input,
    Icon,
    LoadingButton,
    SearchFilter,
  },
  props: {
    filters: Object,
    isMainShop: Boolean,
  },
  data() {
    return {
      sending: false,
      shops: [],
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      handler: throttle(function () {
        let query = pickBy(this.form)
        this.$inertia.replace(this.route('stock.stockExtract', Object.keys(query).length ? query : {remember: 'forget'}))
      }, 150),
      deep: true,
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    exportStock() {
      if (this.shops.length === 0) {
        this.shops = [this.$page.props.user.shop.id]
      }
      window.open(this.route('stock.extract', this.shops.join()), "_blank");
    },
  },
}
</script>
